export default __webpack_public_path__ + "static/media/newsletter-icon.ceebc180.svg";